<template>
  <span
    class="grid h-12 w-12 place-items-center rounded border-2 text-center text-xl font-bold"
    :class="classes"
  >
    <slot />
  </span>
</template>

<script>
export default {
  name: 'SearchPaginationButton',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        '': true,
        'hover:cursor-pointer hover:border-blue-50 hover:bg-blue-50':
          this.clickable,
        'bg-white text-grey-30 border-grey-30': this.active,
        'bg-blue-30 text-white border-blue-30 border-b-blue-50': !this.active,
      };
    },
  },
};
</script>
